export const CATALOG_V1_ART_SHOWROOM_RIGHTS = {
    'art-01-la-vague': {
        studioSourceFileName: 'POSTER_ART_No. 01_LA VAGUE.pdf',
        credit: {
            fr: 'Katsushika Hokusai — Sous la vague au large de Kanagawa (La Grande Vague), vers 1830–1832 — domaine public',
            en: 'Katsushika Hokusai — Under the Wave off Kanagawa (The Great Wave), ca. 1830–1832 — public domain',
        },
        underlyingWorkReference: {
            artist: 'Katsushika Hokusai',
            title: {
                fr: 'Sous la vague au large de Kanagawa (La Grande Vague)',
                en: 'Under the Wave off Kanagawa (The Great Wave)',
            },
            date: { fr: 'vers 1830–1832', en: 'ca. 1830–1832' },
            rightsStatus: 'public-domain',
            documentaryReferenceUrl: 'https://www.metmuseum.org/art/collection/search/45434',
            documentaryReferenceRole: 'documentation-only',
        },
        productionAsset: {
            master: {
                path: 'poster-original.pdf',
                byteSize: 936442,
                sha256: '666c88b5a03d273ce43f3c86f06cc8ce99aeb2ac2c2f02bb553b4e4c7f72eb76',
            },
            previewSource: {
                path: 'poster-source.png',
                byteSize: 11169317,
                sha256: '6a2bd34c8ffe8fd85962bd1a2e5b6b8ced1452d18a00fa8ad998c6acbe61a325',
            },
        },
        publicPreviewManifest: [
            {
                assetPath: 'packshot-eshop-v2.png',
                byteSize: 637014,
                sha256: 'f71c60e3250fbc1e60490f5dee2d3e330170cc5312ad6ed6019ec21fa7e7278b',
            },
            {
                assetPath: 'preview-poster-easel.png',
                byteSize: 401256,
                sha256: '51c84bcf0b1aa30647df797fc1ff443296cbf9aac587882bea8d33dddc643e93',
            },
            {
                assetPath: 'preview-poster-tabletop-easel.png',
                byteSize: 834899,
                sha256: '720e8c6f8869513a5146b278996dcaa598e30630f7b98e309df789e5bc69aabb',
            },
            {
                assetPath: 'preview-poster-easel-front-label.png',
                byteSize: 411338,
                sha256: '204ed61a66cd28769771226cc1fc2c0ccac44eb37d359b85b8b26b0b0733e4ea',
            },
            {
                assetPath: 'preview-poster-easel-posed.png',
                byteSize: 533332,
                sha256: '75a401986a1b4e13f6ac82b61945189bc81f2b22565efeaa2471292935b4cbc3',
            },
            {
                assetPath: 'preview-poster-living-room-wall.png',
                byteSize: 1333058,
                sha256: '130ec823fa5278098c9fef04a4d8fe67c0beb0fbd8ae3d35a2c3b8bb0b8f0aa3',
            },
        ],
    },
    'art-02-le-baiser': {
        studioSourceFileName: 'POSTER_ART_No. 02_LE BAISER.pdf',
        credit: {
            fr: 'Gustav Klimt — Le Baiser (Les Amants), 1908–1909 — domaine public',
            en: 'Gustav Klimt — The Kiss (Lovers), 1908–1909 — public domain',
        },
        underlyingWorkReference: {
            artist: 'Gustav Klimt',
            title: { fr: 'Le Baiser (Les Amants)', en: 'The Kiss (Lovers)' },
            date: { fr: '1908–1909', en: '1908–1909' },
            rightsStatus: 'public-domain',
            documentaryReferenceUrl: 'https://www.belvedere.at/en/visit/upper-belvedere',
            documentaryReferenceRole: 'documentation-only',
        },
        productionAsset: {
            master: {
                path: 'poster-original.pdf',
                byteSize: 38414028,
                sha256: '759b7df706f0289affb848607ff96e8b4e4d9d5fabeb40f46354f8567f2dba50',
            },
            previewSource: {
                path: 'poster-source.png',
                byteSize: 15930272,
                sha256: '5250adae954e174f3742f5c89c51a6e230ce23e90f4c83f11e540d3e65b40021',
            },
        },
        publicPreviewManifest: [
            {
                assetPath: 'packshot-eshop-v2.png',
                byteSize: 622757,
                sha256: '6d36c0da9233d3f2a3af21a1a771b559766e7c44fac8fd32b1811578be9d3523',
            },
            {
                assetPath: 'preview-poster-easel.png',
                byteSize: 400995,
                sha256: 'a2a23b095a943b9ee8302b2ba3bb75c3a53d52ce1f2f05b43ebd89f6ab5583f9',
            },
            {
                assetPath: 'preview-poster-tabletop-easel.png',
                byteSize: 862523,
                sha256: '759d67091d1ab8111ef035422e964171597a4a9f1c01c20cb880f25d356b562c',
            },
            {
                assetPath: 'preview-poster-easel-front-label.png',
                byteSize: 394608,
                sha256: 'd286b595574157a642731f5c623e56eade72330af510987ae613f75467eaa8c2',
            },
            {
                assetPath: 'preview-poster-easel-posed.png',
                byteSize: 553385,
                sha256: 'b890f45c44a6e77b7027230f80b2d6bf9a646f00770131be0bc35b51dbbc9f8b',
            },
            {
                assetPath: 'preview-poster-living-room-wall.png',
                byteSize: 1375788,
                sha256: '1e32e5eff1ceb3ab784724b40a001ce03d75ec3a2d5c09581fde95109cb038f9',
            },
        ],
    },
    'art-03-la-nuit-etoilee': {
        studioSourceFileName: 'POSTER_ART_No. 03_LA NUIT ETOILEE.pdf',
        credit: {
            fr: 'Vincent van Gogh — La Nuit étoilée, Saint-Rémy, juin 1889 — domaine public',
            en: 'Vincent van Gogh — The Starry Night, Saint-Rémy, June 1889 — public domain',
        },
        underlyingWorkReference: {
            artist: 'Vincent van Gogh',
            title: { fr: 'La Nuit étoilée', en: 'The Starry Night' },
            date: { fr: 'Saint-Rémy, juin 1889', en: 'Saint-Rémy, June 1889' },
            rightsStatus: 'public-domain',
            documentaryReferenceUrl: 'https://www.moma.org/collection/works/79802',
            documentaryReferenceRole: 'documentation-only',
        },
        productionAsset: {
            master: {
                path: 'poster-original.pdf',
                byteSize: 1331959,
                sha256: '5cf373eb35deb03dd4687f8e0f08a82200430b100d8c333722cc5fcd7a328ea2',
            },
            previewSource: {
                path: 'poster-source.png',
                byteSize: 13744910,
                sha256: '921fec31082f1d3ce5c49270d5cd8d36ba8775ef74ca92d87af4b63129bf81e9',
            },
        },
        publicPreviewManifest: [
            {
                assetPath: 'packshot-eshop-v2.png',
                byteSize: 653936,
                sha256: '7e5f3926bbf8baeb2aafa10b7a2394ddb796e12dc345da27b4424ece5bc1a558',
            },
            {
                assetPath: 'preview-poster-easel.png',
                byteSize: 437615,
                sha256: 'e78e59c7bf1e48ed4ac601a34eb0f1c393776442e487e4f57af098cdd78c50ff',
            },
            {
                assetPath: 'preview-poster-tabletop-easel.png',
                byteSize: 872504,
                sha256: '617f01e42bae14c9ca31b881a4ce7f11961c41a288466bdcc430d74e36fb6005',
            },
            {
                assetPath: 'preview-poster-easel-front-label.png',
                byteSize: 426196,
                sha256: 'bf4a8f3c4101b0f3e24b204cc451b1e4a10958d652bbe509cde41e2ed8afc1d5',
            },
            {
                assetPath: 'preview-poster-easel-posed.png',
                byteSize: 572861,
                sha256: '75b68526484f75aef0c1de992ef167b9d88000c3bee8f1ddc526167c722e7a65',
            },
            {
                assetPath: 'preview-poster-living-room-wall.png',
                byteSize: 1386232,
                sha256: '0497f1f51d3e8432ad4e28be5543e728cc8f0cc00fe224eeffae9b3accd4154b',
            },
        ],
    },
};
